import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { ProjectConfig } from 'Global';
import Cookies from 'universal-cookie';
import { LinearProgress } from '@mui/material';

const cookies = new Cookies();

interface IAutocompleteList {
  name: string;
  id: number;
}



export default function AutocompleteBrands(props: any) {

  const {value, onChange, error, disabled} = props;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpenList = () => {
  setOpen(true);
  };





  /*=================================================
    CLIENT AUTOCOMPLETE VARIABLES & FUNCTIONS
    =================================================*/
    interface IProjectList {
      inputValue?: string,
      brand_id?: number,
      brand_name: string,
    };
    const filter = createFilterOptions<IProjectList>();

    //setClientList
    const [brandlist, setBrandList] = useState<any []>([]);
    const [brand, setBrand] = useState<IProjectList | null>(null);
    
    useEffect(() => {
      
      axios.get(ProjectConfig.api_url + "/brands/list", 
      {
        headers: {
          "ltkn": localStorage.getItem('ltkn')
        },
        params: {
          full_list: true,
        }
      })
        .then((response) => {
          console.log("BrandList",response.data);
          setBrandList(response.data.list);
          setLoading(true)
           
        })
        .catch((err) => {
          console.log(err.data);
        })
    }, []);
    /* ================================================= 
    ===================================================*/


    let item_name = "";
    if (brandlist && (value && value!=0)) 
    {
      item_name = brandlist.find(obj => {
        return obj.brand_id === parseInt(value); 
      })
    } 
    
    
  return (
    <>
      {brandlist.length > 0 ? (
        <Autocomplete
          value={item_name}
          disabled={disabled}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              setBrand({
                brand_name: newValue,
              });
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              setBrand({
                brand_name: newValue.inputValue,
              });
            } else {
              setBrand(newValue);
              if (newValue?.brand_id!=null)
              {
                onChange({
                    target: {
                        value: newValue.brand_id.toString(),
                        name: "brand_id",
                    }
                })
              }
              else {
                onChange({
                  target: {
                      value: "",
                      name: "brand_id",
                  }
                })
              }
              
            }
            
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            

            return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          autoComplete={false}
          fullWidth
          id="free-solo-with-text-demo"
          options={brandlist}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.brand_name;
          }}
          renderOption={(props, option) => <li className="flex_select" {...props}>
            <div className="flex_option_1">{option.brand_name}</div>
          </li>}
          freeSolo
          renderInput={(params) => (
            <TextField 
            {...params} 
            label="Marca" 
            error={error}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            }}
            
            placeholder='Marca'
            />
          )}
          /> 
        )
        :
        (
          <>
          
          <LinearProgress />
          
          </>
        )
      }
        
      
    </>
  );
}
